import { unknown } from './unknown';
export const blockCard = node => {
  if (!node.attrs.url) {
    return unknown(node);
  }
  return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};